import { APPROVAL_CHAIN_TEMPLATE_MODEL } from "@/models/approval-chain-template-model";
import JSONApiService from "@/services/JSONApiService";
import {
  include,
  USER,
  CLIENT,
  APPROVAL_CHAIN_TEMPLATE_LEVELS,
  USERS,
  nested
} from "@/models/relationships";

const includes = include(
  USER,
  CLIENT,
  APPROVAL_CHAIN_TEMPLATE_LEVELS,
  nested(APPROVAL_CHAIN_TEMPLATE_LEVELS, nested(USERS, USER))
);

const approvalChainTemplateApi = commit => ({
  getAll: params =>
    JSONApiService(commit)
      .all(APPROVAL_CHAIN_TEMPLATE_MODEL)
      .get({ ...includes, ...params }),
  getApprovalChain: id =>
    JSONApiService(commit)
      .one(APPROVAL_CHAIN_TEMPLATE_MODEL, id)
      .get({ ...includes }),
  add: data =>
    JSONApiService(commit).create(APPROVAL_CHAIN_TEMPLATE_MODEL, data),
  edit: data =>
    JSONApiService(commit)
      .one(APPROVAL_CHAIN_TEMPLATE_MODEL, data.id)
      .patch(data)
});

export default approvalChainTemplateApi;
